import { CREATE_CAMPAIGN_ACTIONS } from '../constants/actionsConstants';

const initialState = {
  current_retailer: {},
  createdResponse: null,
  error: null
};

const createCampaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CAMPAIGN_ACTIONS.SET_ALL_QR_CATALOGS:
      return {
        ...state,
        current_retailer: action.data
      };
    case CREATE_CAMPAIGN_ACTIONS.SET_ALL_GUPSHUP_CATALOGS:
      return {
        ...state,
        current_retailer: action.data
      };
    case CREATE_CAMPAIGN_ACTIONS.ADD_NEW_CAMPAIGN:
      return {
        ...state,
        createdResponse: action.payload
      };
    default:
      return state;
  }
};

export default createCampaignReducer;
